import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutEdiStandardCodeLookup extends Layout {
    sourceEdiStandardCode: DataSource;
    tableEdiStandardCode: Table;
}
